import { useState } from 'react'
import { Compose } from './Compose'
import { useParams } from 'react-router'
import { Conversation } from './Conversation'
import { useTw } from '../../../../../utils/Styles'
import { useConversationQuery } from './Conversation.generated'
import { usePostConversationV2Mutation } from './PostConversation.generated'

export function Messages() {
  const tw = useTw()
  const { id } = useParams()
  const [mutate] = usePostConversationV2Mutation()
  const [shouldFetchMore, setFetchMore] = useState(true)
  const { data, loading, fetchMore } = useConversationQuery({
    variables: { id },
  })

  return (
    <section className={tw`flex flex-col h-full`}>
      <Conversation
        loading={loading}
        done={data?.Conversation?.done}
        data={data?.Conversation.messages}
        onNext={() => {
          if (shouldFetchMore && !loading) {
            const length = data?.Conversation.messages.length
            fetchMore({
              variables: {
                id,
                after: data?.Conversation.messages[length - 1]._id,
              },
            }).then(({ data }) => {
              setFetchMore(data?.Conversation.messages?.length === 10)
            })
          }
        }}
      />
      {data?.Conversation?.done === false ? (
        <Compose
          onSend={(message, attachments) =>
            mutate({
              variables: {
                conversationId: id,
                data: { attachments, message },
              },
            })
          }
        />
      ) : null}
    </section>
  )
}
